import React, { useMemo } from 'react';
import { Alert } from '@twilio-paste/alert';
import { Text } from '@twilio-paste/core/text';
import { content } from '../content';
import { Anchor } from '@twilio-paste/core';

export interface Props {
  hasDiscount: boolean;
  isEiEnding: boolean;
  isMcEnding: boolean;
  trialEndDate: string;
}

export const TrialEnding: React.VFC<Props> = ({
  trialEndDate,
  isEiEnding,
  isMcEnding,
  hasDiscount,
}) => {
  const { both, ei, mc } = useMemo(() => content.trialEnding(trialEndDate), [
    trialEndDate,
  ]);

  const infoText = useMemo(() => {
    if (isEiEnding && isMcEnding) {
      return both;
    }
    if (isEiEnding) {
      return ei;
    }
    if (isMcEnding) {
      return mc;
    }
    return null;
  }, [both, ei, mc, isEiEnding, isMcEnding]);

  const upgradeText = useMemo(() => {
    const { withDiscount, noDiscount } = content.upgradeText;
    if (!hasDiscount) {
      return noDiscount;
    }
    return withDiscount;
  }, [hasDiscount]);

  return (
    <Alert variant="neutral">
      <Text as="p">
        {infoText}{' '}
        <Anchor href={content.upgradeLink.href}>
          {content.upgradeLink.text}
        </Anchor>{' '}
        {upgradeText}{' '}
      </Text>
    </Alert>
  );
};
